module.exports = __webpack_public_path__ + "static/media/secondBanner.0044b688.jpg";